'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require('../../../../');

exports.default = {
  clientInfo: {
    client_type: 'dedicated'
  },
  config: {
    id: '',
    theme: 'theme-background-color-green',
    backgroundPosition: 'center',
    backgroundImage: {
      url: ''
    }
  },
  content: {
    image: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/online-sellers-solutions/Icon_4.png'
    },
    headline: {
      text: '50 characters (2 lines) maximum.'
    },
    paragraph: {
      text: '150 characters (3 lines) maximum'
    },
    actionDropdown: _.ActionDropdown.defaultProps,
    cta: {
      text: 'Fewer Than 29 Characters Max',
      href: '#',
      'data-pa-click': 'cta|CTA Text',
      target: '_self'
    },
    mediaButton: {
      id: '',
      text: 'This is Media Button',
      'data-video-id': 'rquuf4XfwLA',
      fpti: ''
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    }
  },
  className: 'theme-new-money',
  callback: function callback() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/fees-pullout/props/default.js
// module id = 1092
// module chunks = 4